var render = function render(_c,_vm){return _c('p',{class:`break-words text-sm text-gray-700 line-clamp-3 ${
    _vm.data.class || ''
  }`},[_vm._v(" "+_vm._s(_vm.props.project.description)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }